import React from 'react'
import { useTranslation } from 'react-i18next'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { COLOR_SETTINGS } from '../../routes/color-constants'
import { IMPROVEMENTS } from './improvements'

export const Improvements = () => {
    const { t } = useTranslation()

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ color: COLOR_SETTINGS }}>{t('version')}</TableCell>
                        <TableCell style={{ color: COLOR_SETTINGS }}>{t('date')}</TableCell>
                        <TableCell style={{ color: COLOR_SETTINGS }}>{t('improvements')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {IMPROVEMENTS.map((i) => (
                        <TableRow key={i.version}>
                            <TableCell>{i.version}</TableCell>
                            <TableCell>{new Date(i.date).toLocaleDateString()}</TableCell>
                            <TableCell>
                                <ul>
                                    {i.improvements.map((imp) => (
                                        <li key={imp}>{imp}</li>
                                    ))}
                                </ul>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}